import clsx from 'clsx'

import { Divider } from '@heroui/react'
import styles from './arrow-divider.module.scss'
import IconArrowRightShort from '@/components/icons/icon-arrow-right-short'

const size = 24

export interface ArrowDividerBodyProps {
  children?: React.ReactNode
  reverse?: boolean
  withBottomMargin?: boolean
  onClick?: () => void
}

/** Minimal logic, will be dispalyed in skeleton */
export function ArrowDividerBody({ children: picker, reverse, onClick, withBottomMargin }: ArrowDividerBodyProps) {
  return (
    <div className={clsx(styles.divider, { [styles.withPicker]: picker, [styles.withBottomMargin]: withBottomMargin })}>
      {picker}
      <Divider />
      <div onClick={onClick} className={clsx(styles.arrow, 'bg-content1', {
        [styles.reverse]: reverse,
      })}>
        <IconArrowRightShort width={size} height={size} />
      </div>
    </div>
  )
}
